import { useForm, type UseFormReturn } from 'react-hook-form';
import type { EditCardFormValues } from './types';
import { zodResolver } from '@hookform/resolvers/zod';
import { useTranslation } from 'react-i18next';
import { editCardFormSchema } from './validation';
import type { SavedCard } from '@/entities/card';

type Props = {
  savedCard: SavedCard;
};

type Params = {
  form: UseFormReturn<EditCardFormValues>;
};

export const useEditCardForm = ({ savedCard }: Props): Params => {
  const { t } = useTranslation();

  const schema = editCardFormSchema(t);

  const form = useForm<EditCardFormValues>({
    mode: 'onSubmit',
    resolver: zodResolver(schema),
    defaultValues: {
      cardNumber: savedCard.cardNumber,
      cardholderName: savedCard.cardholderName,
      templateName: savedCard.templateName,
    },
  });

  return {
    form,
  };
};
